import { LocationIQGeocoder } from './LocationIQGeocoder'

export class Geocoder {
  static get instance () {
    if (!this._instance) {
      this._instance = new LocationIQGeocoder()
    }

    return this._instance
  }
}
